import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getFormatedPrice } from '../../../helpers/getFormatedPrice';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { getProductType } from '../../../helpers/getProductType';
import { getRequiredDepthForShutters } from '../../../helpers/getRequiredDepthForShutters';
import { getRequiredDepthForVenetians } from '../../../helpers/getRequiredDepthForVenetians';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Extra } from '../../Common/Extra';
import { Heading } from '../../Common/Heading';
import {
  Selector,
  SelectorImageItem,
  SelectorItem,
} from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  venetianValance: number | 'no',
  venetianValancePrice: number,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (
  venetianValance,
  venetianValancePrice,
  send,
) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      venetianValance,
      venetianValancePrice,
    },
  });
};

export const VenetianValance = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    venetianValance: venetianValanceAddonProducts,
    custom: { venetianValance, measurements, slatSize },
  } = state.context;

  const productSubType = getProductType(state.context);

  if (
    isCurrentState('venetianValance', state) &&
    venetianValanceAddonProducts.length === 0
  ) {
    throwError(state);
  }

  const venetianType = state.context.products[0].type.replace('Venetian ', '');

  const venetianTypeWithoutDriveControl = venetianType.includes('Corded')
    ? venetianType.replace('Corded', '').trim()
    : venetianType.includes('Cordless')
    ? venetianType.replace('Cordless', '').trim()
    : venetianType.trim();

  const venetianValanceOptions = venetianValanceAddonProducts[0].variants.filter(
    variant => variant.title.includes(venetianTypeWithoutDriveControl),
  );
  let variantIndex = 0;
  let venetianValanceVariantId = 0;
  let venetianValanceVariantPrice = 0;
  if (isCurrentState('venetianValance', state)) {
    const width = measurements.split('x')[0];
    venetianValanceOptions.map((variant, index) => {
      const fasciaWidth = variant.title.split('m')[0];
      if (parseInt(width, 10) <= parseInt(fasciaWidth, 10) && index === 0)
        variantIndex = index;
      if (parseInt(width, 10) > parseInt(fasciaWidth, 10)) {
        return (variantIndex =
          index !== venetianValanceOptions.length - 1
            ? variantIndex + 1
            : index);
      }
    });

    venetianValanceVariantId = venetianValanceOptions[variantIndex].id;
    venetianValanceVariantPrice = venetianValanceOptions[variantIndex].price;
  }

  const requiredDepthWithValance = getRequiredDepthForVenetians(
    typeof productSubType === 'string' ? productSubType : '',
    true,
    typeof slatSize === 'string' ? slatSize : '',
  );

  const requiredDepthWithoutValance = getRequiredDepthForVenetians(
    typeof productSubType === 'string' ? productSubType : '',
    false,
    typeof slatSize === 'string' ? slatSize : '',
  );

  const productType = getBaseProductType(state.context);
  return (
    <SectionContent>
      <Heading>Add a Valance</Heading>
      {requiredDepthWithValance &&
        requiredDepthWithoutValance &&
        requiredDepthWithoutValance.length > 0 &&
        requiredDepthWithValance.length > 0 && (
          <Caption>
            Required depth of your window for a Valance is{' '}
            {requiredDepthWithValance[0].depth}, without is{' '}
            {requiredDepthWithoutValance[0].depth}
          </Caption>
        )}
      <Selector isSlider={true}>
        <SelectorImageItem
          key={venetianValanceVariantId}
          isSelected={venetianValance === venetianValanceVariantId}
          showIcon={
            getProductStateConfig(productType, 'venetianValance', 'Yes')
              .showIcon
          }
          Icon={
            getProductStateConfig(productType, 'venetianValance', 'Yes').Icon
          }
          onClick={onClick(
            venetianValanceVariantId,
            venetianValanceVariantPrice,
            send,
          )}
        >
          Venetian Valance{' '}
          <Extra> + {getFormatedPrice(venetianValanceVariantPrice)} </Extra>
        </SelectorImageItem>

        <SelectorImageItem
          key="no"
          isSelected={venetianValance === 'no'}
          showIcon={
            getProductStateConfig(productType, 'venetianValance', 'No').showIcon
          }
          Icon={
            getProductStateConfig(productType, 'venetianValance', 'No').Icon
          }
          onClick={onClick('no', 0, send)}
        >
          No, thanks
        </SelectorImageItem>
      </Selector>
    </SectionContent>
  );
};
